<template>
  <div class="container">
    <br/><br/>
    <h1 class="step-title">
      <img src="@/assets/images/common/img_privacy.png" alt="" />
    </h1>
    <h4 class="step-sub-title text-center">개인 정보 변경 완료</h4>
    <p class="step-sub-content text-center">
      개인 정보 변경이
      <br/>
      정상적으로 완료 되었습니다.
    </p>
    <br/><br/>
    <div class="bottom-btn">
      <v-btn color="mainColorDark" x-large depressed block class="mb-3 btn-text-white" @click="clickHome">홈으로</v-btn>
    </div>
  </div>
</template>

<script>
import Header from "../../commonComp/WS-Header.vue";

export default {
  components: { Header },
  methods: {
    clickHome() {
      this.$router.push({ path: '/home' }).catch(() => {});
    }
  },
};
</script>
